import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const RoleCredentialsGuide = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const roles = [
    { role: 'Client', icon: 'User', email: 'client@plumberpro.fr', password: '', description: 'Accès au portail client pour réserver et suivre vos services', color: '#3b82f6' },
    { role: 'Technicien', icon: 'Wrench', email: 'technicien@plumberpro.fr', password: '', description: 'Gestion des interventions quotidiennes et parcours', color: '#22c55e' },
    { role: 'Dispatch', icon: 'Radio', email: 'dispatch@plumberpro.fr', password: '', mfa: true, description: 'Centre de contrôle pour la planification et le suivi', color: '#eab308' },
    { role: 'Formateur', icon: 'BookOpen', email: 'formateur@plumberpro.fr', password: '', description: 'Gestion du catalogue et des standards de qualité', color: '#8b5cf6' },
    { role: 'Administrateur', icon: 'Settings', email: 'admin@plumberpro.fr', password: '', mfa: true, description: 'Accès complet au système et aux analyses', color: '#ef4444' }
  ];

  const copyToClipboard = (text) => {
    navigator.clipboard?.writeText(text);
  };

  return (
    <div className="glass-panel rounded-2xl overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-6 py-4 flex items-center justify-between hover:bg-white/5 transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: "rgba(139, 92, 246, 0.15)" }}>
            <Icon name="Key" size={20} style={{ color: "#8b5cf6" }} />
          </div>
          <div className="text-left">
            <h3 className="text-sm font-semibold text-white">
              Identifiants de démonstration
            </h3>
            <p className="text-xs text-gray-400">
              Testez les différents rôles utilisateur
            </p>
          </div>
        </div>
        <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={20} style={{ color: "#9ca3af" }} />
      </button>

      {isExpanded && (
        <div className="px-6 pb-6 space-y-4 border-t border-gray-700">
          <div className="pt-4 space-y-3">
            {roles?.map((roleData, index) => (
              <div key={index} className="rounded-lg p-4 space-y-3" style={{ background: "rgba(17, 24, 39, 0.5)" }}>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${roleData?.color}20` }}>
                    <Icon name={roleData?.icon} size={20} style={{ color: roleData?.color }} />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <h4 className="text-sm font-semibold text-white">
                        {roleData?.role}
                      </h4>
                      {roleData?.mfa && (
                        <span className="px-2 py-0.5 rounded text-xs font-medium" style={{ background: "rgba(234, 179, 8, 0.2)", color: "#eab308" }}>
                          MFA: 123456
                        </span>
                      )}
                    </div>
                    <p className="text-xs text-gray-400 mt-1">
                      {roleData?.description}
                    </p>
                  </div>
                </div>

                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <div className="flex-1 rounded px-3 py-2" style={{ background: "rgba(0,0,0,0.3)" }}>
                      <p className="text-xs text-gray-500 mb-1">Email</p>
                      <p className="text-sm font-mono text-gray-300">
                        {roleData?.email}
                      </p>
                    </div>
                    <button
                      onClick={() => copyToClipboard(roleData?.email)}
                      className="p-2 rounded transition-colors hover:bg-white/10"
                    >
                      <Icon name="Copy" size={16} style={{ color: "#9ca3af" }} />
                    </button>
                  </div>

                  <div className="flex items-center gap-2">
                    <div className="flex-1 rounded px-3 py-2" style={{ background: "rgba(0,0,0,0.3)" }}>
                      <p className="text-xs text-gray-500 mb-1">Mot de passe</p>
                      <p className="text-sm font-mono text-gray-300">
                        {roleData?.password || '••••••••'}
                      </p>
                    </div>
                    <button
                      onClick={() => copyToClipboard(roleData?.password)}
                      className="p-2 rounded transition-colors hover:bg-white/10"
                    >
                      <Icon name="Copy" size={16} style={{ color: "#9ca3af" }} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="rounded-lg p-3" style={{ background: "rgba(59, 130, 246, 0.1)", border: "1px solid rgba(59, 130, 246, 0.3)" }}>
            <div className="flex items-start gap-2">
              <Icon name="AlertCircle" size={16} style={{ color: "#3b82f6" }} />
              <p className="text-xs text-gray-400">
                Ces identifiants sont uniquement pour la démonstration. En production, utilisez vos propres identifiants sécurisés.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RoleCredentialsGuide;